export const ItemTypes = {
    MAKEUP: "makeup"
};
